/**
 * This is the product catalog ID for the Cloud Manager product
 * It is how we uniqely identify our product from others within
 * the SK ecosystem
 */
const CloudManagerProductTypeId = 'be60065c-8079-4e84-8eb1-ba87c341004f';

/**
 * This is the product offering ID for the Cloud Manager trial
 */
const CloudManagerTrialProductOfferingId = 'f89b369b-39d3-4cd4-a9d9-d091befa0f2c';

/**
 * This is the license id for the Cloud Manager user type
 */
const CloudManagerUserLicenseId = 'd5f58783-bae6-4bb4-bd60-54c112aef5c6';

/**
 * This is the license id for the advanced permission feature license
 */
const CloudManagerAdvancedPermissionsFeatureLicenseId = 'a9d801ae-259c-4ea8-ae77-f2623e3c6c9c';

/**
 * This is the product type ID for the Asio product
 */
const AsioProductTypeId = 'cef65310-df16-4c00-a2cc-0bebd8a2b7e4';

export {
    AsioProductTypeId,
    CloudManagerAdvancedPermissionsFeatureLicenseId,
    CloudManagerProductTypeId,
    CloudManagerTrialProductOfferingId,
    CloudManagerUserLicenseId,
};
